import { useAppSelector } from "../../../store/hooks/useAppSelector";
import { RootState } from "../../../store/types/rootState";
import { IRaffle } from "../../../store/interfaces/IRaffle";
import { BANK_ACCOUNTS, BankAccountItem } from "../../../constants/bankAccounts";
import { Bar } from 'react-chartjs-2';
import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { getPrimaryColorByAccountId } from "../../../utils/styleConstants";
import { AccountReportData } from "../../../store/interfaces/IReportsData";

interface TargetBankAccountsProps {
  raffle: IRaffle;
  data: AccountReportData;
}

export const TargetBankAccounts = ({ data }: TargetBankAccountsProps) => {
  const accountId = useAppSelector(({ account }: RootState) => account.id);
  
  const primaryColor = getPrimaryColorByAccountId(accountId);
  const formateador = new Intl.NumberFormat('es-CL')
  return (
    <Grid container>
      <Grid sm={12} md={12} lg={12} xl={12} xs={12}>
        <TableContainer>
          <Table>
            <TableHead sx={{
              background: primaryColor,
            }}>
              <TableRow>
                <TableCell>
                  <Typography color={"black"} fontWeight={"bold"}>
                    Cuenta
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color={"black"} fontWeight={"bold"}>
                    Ordenes de compra
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color={"black"} fontWeight={"bold"}>
                    Tickets vendidos
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color={"black"} fontWeight={"bold"}>
                    Ganancias
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data && data.table.map((poStatus, index) => (
                <TableRow key={poStatus.account}>
                  <TableCell>{poStatus.account}</TableCell>
                  <TableCell>{poStatus.purchaseOrdersCount}</TableCell>
                  <TableCell>{poStatus.soldTickets ?? '0'}</TableCell>
                  <TableCell>{formateador.format(poStatus.earnings) ?? '0'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      <Grid sm={12} md={12} lg={12} xl={12} xs={12}>
        {data && (
          <Bar
            options={{
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  display: true,
                },
              },
            }}
            style={{
              height: 220,
            }}
            data={{
              labels: data.chart.labels,
              datasets: [
                {
                  label: 'Tickets vendidos',
                  data: data.chart.soldTickets || [],
                  backgroundColor: primaryColor,
                  borderWidth: 1,
                },
                {
                  label: 'Ganancias',
                  data: data.chart.earnings || [],
                  backgroundColor: '#4caf50',
                  borderWidth: 1,
                },
              ],
            }}
          />
        )}
      </Grid>
    </Grid>
  );
};
